// organize-imports-ignore
import React from 'react';
import { BaseDishTypeIcon, SVGProps } from './BaseDishTypeIcon';
import { APPETIZER, BEVERAGE, BREAKFAST, DESSERT, DINNER, KIDS, LUNCH, MAIN, SIDE } from './iconPaths';

export const DishTypeAppetizer = (props: SVGProps) => <BaseDishTypeIcon {...props} {...APPETIZER} />;

export const DishTypeBeverage = (props: SVGProps) => <BaseDishTypeIcon {...props} {...BEVERAGE} />;

export const DishTypeBreakfast = (props: SVGProps) => <BaseDishTypeIcon {...props} {...BREAKFAST} />;

export const DishTypeDessert = (props: SVGProps) => <BaseDishTypeIcon {...props} {...DESSERT} />;

export const DishTypeDinner = (props: SVGProps) => <BaseDishTypeIcon {...props} {...DINNER} />;

export const DishTypeKids = (props: SVGProps) => <BaseDishTypeIcon {...props} {...KIDS} />;

export const DishTypeLunch = (props: SVGProps) => <BaseDishTypeIcon {...props} {...LUNCH} />;

export const DishTypeMain = (props: SVGProps) => <BaseDishTypeIcon {...props} {...MAIN} />;

export const DishTypeSide = (props: SVGProps) => <BaseDishTypeIcon {...props} {...SIDE} />;
